var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitsAndHarms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65.5229,
    height: 65.5229,
    rx: 32.7615,
    fill: "#F9EBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4502 21.325V24.7651H13.9282V21.325H27.4502ZM22.8514 16.1647V30.1901H18.5754V16.1647H22.8514Z",
    fill: "#A02524"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5947 42.2887V45.3605H40.3247V42.2887H51.5947Z",
    fill: "#A02524"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0688 13.1589L51.5949 14.5076L18.1385 52.364L16.6124 51.0153L50.0688 13.1589Z",
    fill: "#A02524"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsAndHarms);
export default __webpack_public_path__ + "static/media/benefits_and_harms.64fa12c121b9034bb3da05226de4dbb3.svg";
export { ForwardRef as ReactComponent };